export default class CounselingAndConsultancyListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, Requests, $sessionStorage) {
    var counselingAndConsultancyVm = this;
    const currentUser = JSON.parse($cookies.get('currentUser'))
    counselingAndConsultancyVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    counselingAndConsultancyVm.$sessionStorage = $sessionStorage

    counselingAndConsultancyVm.gradRoleClass = 'grad-1'
    counselingAndConsultancyVm.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]

    //VARIABLES
    counselingAndConsultancyVm.dataList = []
    counselingAndConsultancyVm.viewLoaded = false    
    let post = {
        workplanId: currentUser.workplanId,
        teacherId: currentUser.teacherId,
    }
    counselingAndConsultancyVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')

    counselingAndConsultancyVm.active = GlobalConfig.generals.active
    counselingAndConsultancyVm.notActive = GlobalConfig.generals.notActive
    counselingAndConsultancyVm.planningFinish = true
    $scope.classPlanning = ''
    counselingAndConsultancyVm.feedback =  0

    //METHODS
    counselingAndConsultancyVm.updateView = updateView
    counselingAndConsultancyVm.confirmDeleteCounseling = confirmDeleteCounseling
    counselingAndConsultancyVm.getGeneralsWorkplan = getGeneralsWorkplan
    counselingAndConsultancyVm.bitacora = bitacora


    activate();


    function activate(){
      if(counselingAndConsultancyVm.workPlanGeneralList != undefined){
        counselingAndConsultancyVm.status = counselingAndConsultancyVm.workPlanGeneralList.wokplanTeacherStatus[0]
        counselingAndConsultancyVm.stages = counselingAndConsultancyVm.workPlanGeneralList.stages
        counselingAndConsultancyVm.feedback = counselingAndConsultancyVm.status.feedbackReviewed
        counselingAndConsultancyVm.workplanTeacherId = counselingAndConsultancyVm.status.workplanTeacherId
        isPlanning(counselingAndConsultancyVm.status, counselingAndConsultancyVm.stages)
        
        if(counselingAndConsultancyVm.feedback && !counselingAndConsultancyVm.planningFinish){
          getDataFormAdviceConsultancyReject()
        }else{
          getDataFormAdviceConsultancy()
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(counselingAndConsultancyVm.feedback && !counselingAndConsultancyVm.planningFinish){
            getDataFormAdviceConsultancyReject()
          }else{
            getDataFormAdviceConsultancy()
          }
        })
      }

      updateView() 
    }

    function getDataFormAdviceConsultancy(){
      WorkPlanSrv.getDataFormAdviceConsultancy.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.listAdviceConsultancy)
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(listAdviceConsultancy)
        }
      )
    }

    function getDataFormAdviceConsultancyReject(){
      WorkPlanSrv.getDataFormAdviceConsultancyReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.listAdviceConsultancy)
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(listAdviceConsultancy)
        }
      )
    }

    function loadData(data){
      counselingAndConsultancyVm.dataList = data
    }

    function updateView () {
      counselingAndConsultancyVm.viewLoaded = false
      $timeout(() => {
        counselingAndConsultancyVm.viewLoaded = true
      }, 1)
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          counselingAndConsultancyVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          counselingAndConsultancyVm.status = dataReturn.data.wokplanTeacherStatus[0]
          counselingAndConsultancyVm.stages = dataReturn.data.stages
          counselingAndConsultancyVm.feedback = counselingAndConsultancyVm.status.feedbackReviewed
          counselingAndConsultancyVm.workplanTeacherId = counselingAndConsultancyVm.status.workplanTeacherId
          isPlanning(counselingAndConsultancyVm.status, counselingAndConsultancyVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      counselingAndConsultancyVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          counselingAndConsultancyVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == counselingAndConsultancyVm.active){        
          counselingAndConsultancyVm.planningFinish = true
          if (counselingAndConsultancyVm.startDateReview < counselingAndConsultancyVm.currentDate || status.reviewedFinish == counselingAndConsultancyVm.active){
            counselingAndConsultancyVm.planningFinish = true
          }else if (status.reviewedReject == counselingAndConsultancyVm.active){
            counselingAndConsultancyVm.planningFinish = false
          }
        } else {
          counselingAndConsultancyVm.planningFinish = false
        }
      }else{
        counselingAndConsultancyVm.planningFinish = true
      }

      $scope.classPlanning = (counselingAndConsultancyVm.planningFinish ? "disabled" : " ")
    }

    function confirmDeleteCounseling (couseling) {   
      let name = couseling.name
      let workplanTeacherActivityId = couseling.workplanTeacherActivityId
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.name = name
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.delete = function () {
            WorkPlanSrv.disableActivityResearch.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                showDeletedSuccessfully(ctrlModalVM.name)
                removeFromCaroussel(couseling)
                WorkPlanIndicatorSrv.setVariable(true)
                $mdDialog.hide()
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {

            })
            
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedSuccessfully(name){
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : name,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })  
    }
    
    function removeFromCaroussel(couseling){
      for(var i in counselingAndConsultancyVm.dataList){
        if(counselingAndConsultancyVm.dataList[i].workplanTeacherActivityId === couseling.workplanTeacherActivityId){
          counselingAndConsultancyVm.dataList.splice(i,1)
          updateView()
          break
        }
      }
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.consultancy,
        workplanTeacherId: counselingAndConsultancyVm.workplanTeacherId
      }
      entries.title = 'Consultoría y asesoría'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }


  }
}

CounselingAndConsultancyListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/counselingAndConsultancy/list/counselingAndConsultancyListCtrl.js